const relativeTimeFormat = new Intl.RelativeTimeFormat("en", {
  numeric: "auto",
});

/** "just now" / "3 minutes ago" / "2 hours ago" / "yesterday" / "5 days ago" */
export function formatTimeAgo(iso: string, now: number): string | null {
  const then = new Date(iso).getTime();
  if (Number.isNaN(then)) return null;

  const seconds = Math.max(0, Math.round((now - then) / 1000));
  if (seconds < 60) return "just now";

  const minutes = Math.round(seconds / 60);
  if (minutes < 60) return relativeTimeFormat.format(-minutes, "minute");

  const hours = Math.round(minutes / 60);
  if (hours < 24) return relativeTimeFormat.format(-hours, "hour");

  return relativeTimeFormat.format(-Math.round(hours / 24), "day");
}
